module.exports = __webpack_public_path__ + "img/Aayu-Show.22733d6e.png";